import { createStore, applyMiddleware } from 'redux';
import { combineReducers } from 'redux';
import { thunk } from 'redux-thunk';
import authReducer from './reducers/authReducer';
import apiReducer from './reducers/apiReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  apiData: apiReducer,
});

const store = createStore(rootReducer, applyMiddleware(thunk)); // Usar thunk como middleware

export default store;
